var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.75;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2,8.2c0-0.6,0.1-1,0.4-1.3C2.6,6.7,3,6.5,3.5,6.5c0.5,0,0.9,0.1,1.1,0.4C4.9,7.2,5,7.6,5,8.2 c0,0.5-0.1,1-0.4,1.3S4,9.9,3.5,9.9C3,9.9,2.6,9.8,2.4,9.5S2,8.7,2,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.9,8.2c0-0.6,0.1-1,0.4-1.3c0.3-0.3,0.6-0.4,1.1-0.4c0.5,0,0.8,0.1,1.1,0.4s0.4,0.7,0.4,1.3 c0,0.5-0.1,1-0.4,1.3c-0.3,0.3-0.6,0.4-1.1,0.4c-0.5,0-0.9-0.1-1.1-0.4S10.9,8.7,10.9,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2,16.2c0-0.6,0.1-1,0.4-1.3c0.3-0.3,0.6-0.4,1.1-0.4c0.5,0,0.9,0.1,1.1,0.4C4.9,15.2,5,15.6,5,16.2 c0,0.5-0.1,1-0.4,1.3S4,17.9,3.5,17.9c-0.5,0-0.9-0.1-1.1-0.4S2,16.7,2,16.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.1d907bb452b90d3e6591999dd81de84c.svg";
export { ForwardRef as ReactComponent };